import React, { useState, useEffect } from 'react'
import { Checkbox, Col, Form, FormGroup, Panel, Radio, RadioGroup, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import InputForm from '../../components/forms/input/InputForm'
import { cloneDeep, isEmpty } from 'lodash-es'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { doneLoading, startLoading } from '../../utils/loading'
import { saveTrackingDetail } from '../../redux/actions/subprojectTrackingHistory'
import scrollToComponent from 'react-scroll-to-component'
import { setAlertMessage } from '../../utils/messageUtil'
import { CANCEL, DEFAULT_ERR_MSG, SAVE, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { SUB_PROJECT_CODE, SUB_PROJECT_ID } from '../../constants/constants'
import InputInlineForm from '../../components/forms/input/InputInlineForm'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import ReactQuillFrom from '../../components/forms/input/ReactQuill/ReactQuillFrom'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function ProjectMonitorRecordInputWidgets({ schema, refId, ...props }) {
  // const { schema, header } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const [tempSchema, setTempSchema] = useState(schema)
  const [objectsValues, setObjectsValues] = useState(new Map())
  const [isRefash, setIsRefash] = useState(false)

  const objectsValuesName = 'objectsValues'

  const projectCode = sessionStorage.getItem(SUB_PROJECT_CODE)
  const projectId = sessionStorage.getItem(SUB_PROJECT_ID)

  useEffect(() => {
    onLoadData(schema)
  }, [])

  const onLoadData = (schema) => {
    let datas = schema?.values || []
    let objMap = new Map()

    setDataToMap(datas, objMap)
    setObjectsValues(objMap)
    setValue(objectsValuesName, datas)
  }

  const setDataToMap = (datas, objMap) => {
    datas?.forEach((e) => {
      objMap.set(e.id, e.value)

      e.moreInputs?.forEach((se) => {
        objMap.set(se.id, se.value)
      })

      e.inputOptions?.forEach((io) => {
        if (io.moreInputs) {
          setDataToMap(io.moreInputs, objMap)
        }
      })

      e.options?.forEach((io) => {
        if (io.moreInputs) {
          setDataToMap(io.moreInputs, objMap)
        }
      })

      if (e.childs) {
        setDataToMap(e.childs, objMap)
      }
    })
  }

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      let response = await saveTrackingDetail(request)

      if (response) {
        setFormSchema(response)
        setTempSchema(response)
        onLoadData(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG)
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
        onRefash()
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      //console.log('error ', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
    setIsLoading(false)
  }

  const setReQuestData = (datas) => {
    var result = []

    datas?.forEach((e) => {
      if (!isEmpty(e.type) && e.type != 'LABEL') {
        result.push({ refId: e.id, value: objectsValues.get(e.id) })
      }

      var moInput = setReQuestData(e.moreInputs)

      var inputOptionMO = []
      e.inputOptions?.forEach((io) => {
        inputOptionMO = [...inputOptionMO, ...setReQuestData(io.moreInputs)]
      })

      var optionMO = []
      e.options?.forEach((io) => {
        optionMO = [...optionMO, ...setReQuestData(io.moreInputs)]
      })

      var childs = setReQuestData(e.childs)

      result = [...result, ...moInput, ...optionMO, ...inputOptionMO, ...childs]
    })

    return result
  }

  const onSubmit = (data) => {
    console.log('data => ', data)
    let datas = []

    datas = setReQuestData(formSchema?.values || [])

    let request = {
      keyId: formSchema?.id,
      refId: refId,
      projectCode: projectCode,
      projectId: projectId,
      values: datas,
    }

    //console.log(request)

    handleSave(request)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const onCancel = () => {
    onLoadData(tempSchema)
    onRefash()
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const onChange = (item, value, refEffect) => {
    let nObj = cloneDeep(objectsValues)
    nObj.set(item.id, value)

    if (refEffect) {
      if (!value) {
        item.moreInputs?.forEach((e) => {
          nObj.set(e.id, null)
        })
      }
      if (item.type == 'RADIO') {
        item.inputOptions?.forEach((e) => {
          if (e.value != value) {
            e.moreInputs?.forEach((me) => {
              nObj.set(me.id, null)
            })
          }
        })
      } else if (item.type == 'DOPDOWN') {
        item.options?.forEach((e) => {
          if (e.value != value) {
            e.moreInputs?.forEach((me) => {
              nObj.set(me.id, null)
            })
          }
        })
      }
    }

    setObjectsValues(nObj)

    setValue(objectsValuesName, nObj)
  }

  const renderInnerInput = (item, tabRight, disabled) => {
    let inputObj

    switch (item.type) {
      case 'INPUT':
        inputObj = (
          <InputForm
            exValue
            schema={item}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onChange={(value) => {
              onChange(item, value)
            }}
            disabled={disabled}
            value={objectsValues?.get(item.id)}
          />
        )
        break
      case 'INPUT_NUMBER':
        inputObj = (
          <Form layout="inline" style={{ marginTop: 10 }}>
            <FormGroup style={{ width: '100%', marginBottom: 5 }}>
              {item.isBolder ? <b>{item.label}</b> : <>{item.label}</>}
              <InputInlineForm
                exValue
                isInputNumber
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                inputWidth={120}
                onChange={(value) => {
                  onChange(item, value)
                }}
                value={objectsValues?.get(item.id)}
                disabled={disabled}
              />
              <label style={{ marginLeft: 10 }}>{item.postLabel}</label>
            </FormGroup>
          </Form>
        )
        break
      case 'INPUT_AREA':
        inputObj = (
          <>
            <InputForm
              exValue
              schema={item}
              rows={4}
              componentClass="textarea"
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              onChange={(value) => {
                onChange(item, value)
              }}
              value={objectsValues?.get(item.id)}
              disabled={disabled}
            />
          </>
        )
        break
      case 'CHECKBOX':
        inputObj = (
          <Checkbox
            onChange={(_, checked) => {
              onChange(item, checked, true)
            }}
            checked={objectsValues?.get(item.id)}
            disabled={disabled}
          >
            {item.label}
          </Checkbox>
        )
        break
      case 'RADIO':
        inputObj = (
          <div>
            <div style={{ marginTop: 10 }}>
              {item.isBolder ? <strong>{item.label}</strong> : item.label}
            </div>
            <RadioGroup
              inline={item.inline}
              name={item.id}
              value={objectsValues?.get(item.id)}
              onChange={(value) => {
                onChange(item, value, true)
              }}
            >
              {item.inputOptions?.map((op) => {
                return (
                  <>
                    <>
                      <Radio value={op.value} disabled={disabled}>
                        {op.label}
                      </Radio>
                      {op.value == objectsValues?.get(item.id) &&
                        op?.moreInputs?.map((e) => {
                          var moDisabled = op.value != objectsValues?.get(item.id)
                          return renderInnerInput(e, true, moDisabled)
                        })}
                    </>
                  </>
                )
              })}
            </RadioGroup>
          </div>
        )
        break
      case 'DOPDOWN':
        inputObj = (
          <InputSelectForm
            exValue
            schema={item}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            disabled={disabled}
            value={objectsValues?.get(item.id)}
            onChange={(value) => {
              onChange(item, value)
            }}
          />
        )
        break
      case 'LABEL':
        inputObj = (
          <div style={{ marginTop: 10 }}>
            {item.isBolder ? <strong>{item.label}</strong> : item.label}
          </div>
        )
        break
      default:
        break
    }

    return (
      <>
        <Row style={{ marginLeft: tabRight ? 40 : undefined }}>
          <Col xs={24} sm={24} md={24} lg={24}>
            {inputObj}

            {item.moreInputs?.map((subItem) => {
              return renderInnerInput(subItem, true, !objectsValues?.get(item.id))
            })}
          </Col>
        </Row>
      </>
    )
  }

  const renderInputs = (datas, tabRight) => {
    return (
      <>
        {datas?.map((item, index) => {
          return (
            <Row style={{ marginLeft: tabRight ? 20 : undefined }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <>{renderInnerInput(item, false)}</>
                {item.childs && renderInputs(item.childs, true)}
              </Col>
            </Row>
          )
        })}
      </>
    )
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel
        style={{ marginBottom: 10, marginTop: 10 }}
        header={schema.header}
        collapsible
        defaultExpanded
        bordered
        ref={(section) => {
          setSection(section)
        }}
      >
        {!isRefash && (
          <div style={{ marginTop: -10 }}>
            {schema.detail && <i>{schema.detail}</i>}
            {renderInputs(schema.values)}
          </div>
        )}

        <>
          <hr />
          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} className="right">
              <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                <SaveButton children={SAVE} disabled={isLoading} onClick={handleSubmit(onSubmit)} />
                <CancelButton children={CANCEL} onClick={onCancel} />
              </div>
            </Col>
          </Row>
        </>
      </Panel>
    </>
  )
}
